import React, { Component } from 'react'
import { observer } from 'mobx-react'
import NextEventsStore from '../stores/NextEventsStore'
import { Grid, Header, Table } from 'semantic-ui-react'
import LoadingWrapper from '../components/LoadingWrapper'
import moment from 'moment'

@observer
class NextEventsScreen extends Component {
  constructor (props) {
    super(props)
    this.nextEventsStore = new NextEventsStore()
  }

  componentDidMount () {
    // fetch next events for clients
    this.nextEventsStore.fetchNextEvent()
  }

  render () {
    const { events, isLoading } = this.nextEventsStore
    return (
      <>
        <Header as='h2'>Prochaines inspections</Header>
        <LoadingWrapper loading={isLoading} message='Chargement en cours...' />
        <Grid>
          <Grid.Row>
            <Grid.Column>
              <Table celled>
                <Table.Header key='header'>
                  <Table.Row>
                    <Table.HeaderCell>Technicien</Table.HeaderCell>
                    <Table.HeaderCell>Client</Table.HeaderCell>
                    <Table.HeaderCell>Adresse</Table.HeaderCell>
                    <Table.HeaderCell>Équipement</Table.HeaderCell>
                    <Table.HeaderCell>Date inspection</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body key='body'>
                  {events.map(event => {
                    return (
                      <Table.Row key={`event_${event.id}`}>
                        <Table.Cell>
                          {event.user.fullName}
                        </Table.Cell>
                        <Table.Cell>
                          {event.client.name}
                        </Table.Cell>
                        <Table.Cell>
                          {event.clients_addresses_equipment.clients_address.address.fullAddress}
                        </Table.Cell>
                        <Table.Cell>
                          {event.clients_addresses_equipment.equipment.name}
                        </Table.Cell>
                        <Table.Cell>
                          {moment(event.date_start).format('HH:mm DD-MM-YYYY')}
                        </Table.Cell>
                      </Table.Row>
                    )
                  })}
                  {!events.length &&
                    <Table.Row>
                      <Table.Cell colSpan='5' textAlign='center'>
                        Aucune inspection planifiée
                      </Table.Cell>
                    </Table.Row>}
                </Table.Body>
              </Table>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </>
    )
  }
}

export default NextEventsScreen
